import { createFeature, createReducer, on } from '@ngrx/store';
import { AuditEvent } from '../../data/notifications/notifications.model';
import {
  MarkAsReadNotification,
  SetNotifications,
  UpdateNotifications,
} from '../actions/notifications.actions';
import { logoutOAuth } from '../actions/session-auth.actions';

export const NOTIFICATIONS_STATE_KEY = 'notifications';

export type NotificationsState = {
  notifications: AuditEvent[];
  isMarkAsRead: boolean;
  type: string | null;
};

const initialState: NotificationsState = {
  notifications: [],
  isMarkAsRead: false,
  type: null,
};

const reducer = createReducer(
  initialState,
  on(logoutOAuth, () => initialState),
  on(
    SetNotifications,
    (state: NotificationsState, { notifications }): NotificationsState => {
      const { list, type } = notifications;

      const newNotificationsIds = list.map((item) => item.id);
      let oldNotifications = state.notifications.filter(
        (n) => !newNotificationsIds.includes(n.id),
      );

      if (!list.length && type === 'messenger') {
        oldNotifications = state.notifications.filter(
          (notification) => !notification.path,
        );
      }

      return {
        ...state,
        notifications: [...oldNotifications, ...list],
      };
    },
  ),
  on(
    UpdateNotifications,
    (state: NotificationsState, { notification }): NotificationsState => {
      const updated = state.notifications.map((stateNotification) => {
        const updateNotification = { ...stateNotification };

        if (updateNotification.id === notification.id) {
          updateNotification.read = true;
        }

        return updateNotification;
      });

      return {
        ...state,
        notifications: [...updated],
      };
    },
  ),
  on(
    MarkAsReadNotification,
    (state: NotificationsState, { isMarkAsRead }): NotificationsState => {
      return {
        ...state,
        isMarkAsRead,
      };
    },
  ),
);

export const notificationsFeature = createFeature({
  name: NOTIFICATIONS_STATE_KEY,
  reducer,
});
